<template>
    <div class="brandList">
        
        <div class="list" v-if="getLng() == 'en'">
            <div v-for="(collection, key) in preloaded.collections" class="listItem" @click="changeToCollection(key)">
                <div class="listIContainer">
                    <div class="imgBox">
                        <img :src="collection.image ? collection.image : getStaticImage('logo.png')" alt="">
                    </div>
                    <div>{{collection.name}}</div>
                </div>
            </div>
            
        </div>
        <div class="list" v-else>
            <div v-for="(collection, key) in preloaded.collectionsSpanish" class="listItem" @click="changeToCollection(key)">
                <div class="listIContainer">
                    <div class="imgBox">
                        <img :src="collection.image ? collection.image : getStaticImage('logo.png')" alt="">
                    </div>
                    <div>{{collection.name}}</div>
                </div>
            </div>
            
        </div>
    
    </div>
</template>

<script>

    import {mapState} from "vuex";
    import $ from "jquery";
    import pageMixin from "../../mixins/page";

    export default {
        name: 'Finest',
        mixins: [pageMixin],
        methods: {
            changeToCollection(key) {
                window.scrollTo({top: 0, behavior: 'smooth'});

                $("#mainContainer>.page").animate({
                    scrollTop: 200
                }, 1000);

                this.$router.push({name: "products", query: {brand: "finest", collection: key}});
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }
        },
        mounted() {
            if (!this.$route.query.product){
                this.changePageTitle("The Best Finest Call & Reàl Cocktail Recipes | ABM Cocktail Pro");
            }
        },
        computed: {
            ...mapState("shared", ["preloaded"])
        }
    }
</script>

